import { Fill, Stroke, Circle, Style } from 'ol/style';

const getRampFillColor = (feature, layerId, ramp) => {
  const { properties_ } = feature;
  let styleValue = Number(properties_[layerId]);

  if (isNaN(styleValue)) {
    styleValue = Number.NEGATIVE_INFINITY;
  }

  const match = ramp.find(({ min, max }) => ((min !== 0 && !min) || styleValue > min) && ((max !== 0 && !max) || styleValue <= max));
  return match.fillColor;
};

const defaultStrokeWidth = 0.4;

const getUniqueFillColor = (feature, layerId, unique) => {
  const { properties_ } = feature;
  const styleValue = properties_[layerId];
  return unique[styleValue] ? unique[styleValue].fillColor : unique.default.fillColor;
};

const getUniqueStrokeColor = (feature, layerId, unique, strokeColor) => {
  const { properties_ } = feature;
  const styleValue = properties_[layerId];

  if (unique[styleValue] && unique[styleValue].strokeColor) {
    return unique[styleValue].strokeColor;
  }

  return unique.default && unique.default.strokeColor ? unique.default.strokeColor : strokeColor;
};

const getUniqueStrokeWidth = (feature, layerId, unique) => {
  const { properties_ } = feature;
  const styleValue = properties_[layerId];

  if (unique[styleValue] && unique[styleValue].strokeWidth) {
    return unique[styleValue].strokeWidth;
  }

  return unique.default && unique.default.strokeWidth ? unique.default.strokeWidth : defaultStrokeWidth;
};

const styleCache = {};

const createPolygonRampStyler = (layerId, ramp, strokeColor) => (feature) => {
  const fillColor = getRampFillColor(feature, layerId, ramp);
  const styleId = `polygon ramp ${fillColor.join()} ${strokeColor.join()}`;
  let style = styleCache[styleId];

  if (!style) {
    style = new Style({
      fill: new Fill({
        color: fillColor,
      }),
      stroke: new Stroke({
        color: strokeColor,
        width: defaultStrokeWidth,
      }),
    });

    styleCache[styleId] = style;
  }

  return style;
};

const createPolygonUniqueStyler = (layerId, unique, layerStrokeColor) => (feature) => {
  const fillColor = getUniqueFillColor(feature, layerId, unique);
  const strokeColor = getUniqueStrokeColor(feature, layerId, unique, layerStrokeColor);
  const strokeWidth = getUniqueStrokeWidth(feature, layerId, unique);

  const styleId = `polygon unique ${fillColor.join()} ${strokeColor.join()} ${strokeWidth}`;
  let style = styleCache[styleId];

  if (!style) {
    style = new Style({
      fill: new Fill({
        color: fillColor,
      }),
      stroke: new Stroke({
        color: strokeColor,
        width: strokeWidth,
      }),
    });

    styleCache[styleId] = style;
  }

  return style;
};

const createPointUniqueStyler = (layerId, unique, size, strokeColor) => (feature) => {
  const fillColor = getUniqueFillColor(feature, layerId, unique);
  const styleId = `point unique ${fillColor.join()} ${strokeColor.join()} ${size}`;
  let style = styleCache[styleId];

  if (!style) {
    style = new Style({
      image: new Circle({
        radius: size,
        fill: new Fill({
          color: fillColor,
        }),
        stroke: new Stroke({
          color: strokeColor,
          width: defaultStrokeWidth,
        }),
      }),
    });

    styleCache[styleId] = style;
  }

  return style;
};

export {
  createPolygonRampStyler,
  createPolygonUniqueStyler,
  createPointUniqueStyler,
};
